import { render, staticRenderFns } from "./JeecgOrderMainList.vue?vue&type=template&id=5f657e3c&scoped=true&"
import script from "./JeecgOrderMainList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderMainList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderMainList.vue?vue&type=style&index=0&id=5f657e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f657e3c",
  null
  
)

export default component.exports